import { routes } from './app.routes';


import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MessageService } from 'primeng/api';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TokenInterceptor } from './services/token.interceptor';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const EnergoPreset = definePreset(Aura, {
  primitive: {
    fontFamily: '"Space Grotesk", sans-serif'
  },
  semantic: {
    primary: {
      50:  '#e9ebfc',
      100: '#d3d6f8',
      200: '#a6aef2',
      300: '#7a85eb',
      400: '#4e5de4',
      500: '#2134de',
      600: '#1b2ab1',
      700: '#141f85',
      800: '#0d1559',
      900: '#070a2c',
      950: '#05071f'
    },
    formField: {
      background: '#ffffff',
      disabledBackground: '#f8f9fc',
      filledBackground: '#f8f9fc',
      filledFocusBackground: '#ffffff',
      borderColor: '#d0d2e3',
      hoverBorderColor: '#9198d4',
      focusBorderColor: '{primary.500}',
      color: '#1d2149',
      placeholderColor: '#9198d4'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8f9fc',
          100: '#f1f2f8',
          200: '#e4e5f0',
          300: '#d0d2e3',
          400: '#9198d4',
          500: '#6c75c6',
          600: '#4753b8',
          700: '#394293',
          800: '#2b326e',
          900: '#1d2149',
          950: '#0e1125'
        }
      }
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(),
    provideAnimationsAsync(),
    importProvidersFrom(
      
      ),
    providePrimeNG({
      theme: {
        preset: EnergoPreset,
        options: {
          darkModeSelector: '.dark'
        }
      },
      translation: {
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        clear: 'Limpiar',
        weekHeader: 'Sem',
        firstDayOfWeek: 1,
        accept: 'Aceptar',
        reject: 'Cancelar',
        emptyMessage: 'No se encontraron resultados',
        emptyFilterMessage: 'No se encontraron resultados',
        choose: 'Elegir',
        upload: 'Subir',
        cancel: 'Cancelar',
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      }
    }),
  ],
};
